import { render } from "./CustomerAsk.vue?vue&type=template&id=e6d0577c&scoped=true"
import script from "./CustomerAsk.vue?vue&type=script&lang=js"
export * from "./CustomerAsk.vue?vue&type=script&lang=js"

import "./CustomerAsk.vue?vue&type=style&index=0&id=e6d0577c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d0577c"]])

export default __exports__